/* Shared autoplay for the Super Tags interactive demos.
   A demo opts in with data-st-autoplay="<preset button selector>" (and an
   optional data-st-autoplay-interval in ms) on its section root. While the
   demo is on screen and untouched, its preset buttons are clicked in turn so
   the demo plays itself, with an "Auto-playing" badge (plus a countdown to
   the next step) on the card. data-st-autoplay-fade="<selectors>" names the
   regions that change on each step - they fade out, the preset applies, and
   they fade back in. Any real interaction inside the demo (pointer, key,
   focus) stops autoplay for good and fades the badge out - programmatic
   clicks fire none of those events, so autoplay never pauses itself. */
(function () {
  if (window.__stDemoAutoplay) return;
  window.__stDemoAutoplay = true;

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var FADE_MS = 240;

  function setup(root) {
    // "@steps" mode: instead of cycling preset buttons, each step calls the
    // root.__stAutoplayStep() function the section's own script provides.
    var stepsMode = root.getAttribute('data-st-autoplay') === '@steps';
    var buttons = stepsMode ? [] : Array.prototype.slice.call(root.querySelectorAll(root.getAttribute('data-st-autoplay')));
    if (!stepsMode && !buttons.length) return;

    var interval = parseInt(root.getAttribute('data-st-autoplay-interval'), 10) || 3000;
    var secs = Math.max(2, Math.round(interval / 1000));
    var card = root.querySelector('[data-st-autoplay-badge]') || root.querySelector('.st-demo__card') || root;

    var fadeSel = root.getAttribute('data-st-autoplay-fade');
    var fadeEls = fadeSel ? Array.prototype.slice.call(root.querySelectorAll(fadeSel)) : [];
    fadeEls.forEach(function (el) { el.style.transition = 'opacity ' + FADE_MS + 'ms ease'; });

    var idx = -1;
    var left = secs;
    var timer = null;
    var stopped = false;

    var badge = document.createElement('div');
    badge.className = 'st-demo__autoplay';
    badge.setAttribute('aria-hidden', 'true');
    badge.innerHTML = '<svg viewBox="0 0 10 12" width="9" height="11" fill="currentColor" aria-hidden="true"><path d="M0 0l10 6-10 6z"/></svg>Auto-playing';
    var count = document.createElement('span');
    count.className = 'st-demo__autoplay-count';
    count.textContent = secs;
    badge.appendChild(count);
    card.appendChild(badge);

    function advance() {
      if (stepsMode) {
        if (typeof root.__stAutoplayStep === 'function') root.__stAutoplayStep();
        return;
      }
      // advance to the next preset, skipping one that's already active
      for (var n = 0; n < buttons.length; n++) {
        idx = (idx + 1) % buttons.length;
        if (!buttons[idx].classList.contains('is-active')) break;
      }
      buttons[idx].click();
    }

    function step() {
      if (!fadeEls.length) { advance(); return; }
      fadeEls.forEach(function (el) { el.style.opacity = '0'; });
      setTimeout(function () {
        if (!stopped) advance();
        requestAnimationFrame(function () {
          fadeEls.forEach(function (el) { el.style.opacity = ''; });
        });
      }, FADE_MS);
    }

    function heartbeat() {
      left--;
      if (left <= 0) { left = secs; step(); }
      count.textContent = left;
    }

    function run() {
      if (timer || stopped) return;
      left = secs;
      count.textContent = secs;
      timer = setInterval(heartbeat, 1000);
    }

    function halt() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function stop() {
      if (stopped) return;
      stopped = true;
      halt();
      io.disconnect();
      fadeEls.forEach(function (el) { el.style.opacity = ''; });
      badge.classList.add('is-hidden');
      setTimeout(function () { badge.remove(); }, 400);
    }

    ['pointerdown', 'keydown', 'focusin'].forEach(function (ev) {
      root.addEventListener(ev, stop, true);
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) run();
        else halt();
      });
    }, { threshold: 0.35 });
    io.observe(card);
  }

  function init() {
    document.querySelectorAll('[data-st-autoplay]').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
